"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
const OptimizelyFlagProviderContext = createContext({ decisions: {} });
const OptimizelyFlagProvider = ({
  decisions = [],
  children
}) => {
  const decisionsKv = useMemo(() => {
    return decisions.reduce(
      (acc, decision) => {
        acc[decision.flagKey] = decision;
        return acc;
      },
      {}
    );
  }, [decisions]);
  return /* @__PURE__ */ jsx(OptimizelyFlagProviderContext.Provider, { value: { decisions: decisionsKv }, children });
};
const useOptimizelyFlagContext = () => {
  return useContext(OptimizelyFlagProviderContext);
};
export {
  OptimizelyFlagProvider,
  OptimizelyFlagProviderContext,
  useOptimizelyFlagContext
};
